import { createQueryKeys } from '@lukemorales/query-key-factory';

import type { FetchPublicSitePageArgs } from '../api/publicSite.api';

import { fetchPublicSitePage } from '../api/publicSite.api';

export const publicSiteQueryKeys = createQueryKeys('publicSite', {
  fetchPage: ({ orgSlug, trainerSlug }: FetchPublicSitePageArgs) => ({
    queryFn: () => fetchPublicSitePage({ orgSlug, trainerSlug }),
    queryKey: [orgSlug, trainerSlug],
  }),
});
